import { BUILD } from './build';
import type { ErrorKitConfig } from '@amp/web-apps-logger/src/errorkit';

const CLASSICAL_MUSIC_PROD_SUBDOMAIN = ['classical'];
const PROJECT_ID = 'onyx-classical';

const getSentryEnv = () => {
    const location =
        typeof window !== 'undefined' && window.location.host.split('.')[0];
    return CLASSICAL_MUSIC_PROD_SUBDOMAIN.includes(location) ? 'prod' : 'dev';
};

export const ERROR_KIT_CONFIG: ErrorKitConfig = {
    project: PROJECT_ID,
    environment: getSentryEnv(),
    release: BUILD,
};
